import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-update-jamabandi',
  templateUrl: './update-jamabandi.component.html',
  styleUrls: ['./update-jamabandi.component.scss']
})
export class UpdateJamabandiComponent implements OnInit {

  public userId: any;

  constructor(
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private apiService: DashboardService,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
  }

  onClickUpdateJamabandi() {
    this.updateJamabandi();
  }

  updateJamabandi() {
    this.loader.start();
    this.apiService
      .getLandGetAreaByKhewatDevOnly()
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();

          if(resp['status'] == 200){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp['msg'],
            });
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: resp['msg'],
            });
          }

        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }
}
